import { render, staticRenderFns } from "./audioRecorder.vue?vue&type=template&id=54b0b5f7&scoped=true"
import script from "./audioRecorder.vue?vue&type=script&lang=js"
export * from "./audioRecorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b0b5f7",
  null
  
)

export default component.exports